import { computed, onMounted } from 'vue'
import { getRecentSwapsController } from './controller'

export const refreshRecentSwaps = (): void => {
  getRecentSwapsController().commands.refresh()
}

export function useRecentSwaps() {
  const controller = getRecentSwapsController()
  onMounted(() => {
    controller.commands.activate()
  })
  return {
    swaps: computed(() => controller.selectors.swaps.value),
    isLoading: computed(() => controller.selectors.isLoading.value),
  }
}

export type { RecentSwap } from './contracts'
